import { Box, Button, Card, Event, Heading, Status, StatusBadge, TextBlock } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "./unlock-remaining-fleet-value-card.scss";
import { GradedSummary } from "services/asset-management/AssetService";

interface Props {
    data: GradedSummary;
    totalAssets: number;
    onResolveAssetRisks?: () => void;
}

interface Segment {
    variant: string;
    label: string;
    count: number;
    status: Status;
}

export const UnlockRemainingFleetValueCard = (props: Props) => {
    const { t } = useTranslation();

    const segments: Segment[] = [
        {
            variant: "var(--theme-success)",
            label: t("AssetManagement.value.unlockRemainingFleetValue.graded"),
            count: props.data.totalGraded,
            status: Status.SUCCESS,
        },
        {
            variant: "var(--app-chart-chartNeutralColor)",
            label: t("AssetManagement.value.unlockRemainingFleetValue.pending"),
            count: props.data.totalPending,
            status: Status.NEUTRAL,
        },
        {
            variant: "var(--color-yellow-700)",
            label: t("AssetManagement.value.unlockRemainingFleetValue.locked"),
            count: props.data.totalLocked,
            status: Status.WARNING,
        },
    ];

    return (
        <Card className={style.fleetCard}>
            <Box columnLayout gap="Sm">
                <Box columnLayout gap={"Xxs"}>
                    <Heading variant="SUBTITLE_1" disableTopSpacing disableBottomSpacing>
                        {t("AssetManagement.value.unlockRemainingFleetValue.title")}
                    </Heading>
                    <TextBlock>
                        {t("AssetManagement.value.unlockRemainingFleetValue.outOfTotalAssets", {
                            count: props.totalAssets,
                        })}
                    </TextBlock>
                </Box>
                <Box className={style.progressBar}>
                    {segments.map((segment) => (
                        <div
                            key={segment.label}
                            className={style.progressBarSegment}
                            style={{
                                backgroundColor: segment.variant,
                                width: props.totalAssets === 0 ? 0 : `${(segment.count / props.totalAssets) * 100}%`,
                            }}
                        />
                    ))}
                </Box>
                <Box columnLayout gap="Xxs">
                    {segments.map((segment, index) => (
                        <Box key={index} verticalAlignment={"Center"}>
                            <StatusBadge
                                value={`${segment.label} · ${segment.count}`}
                                status={segment.status}
                                className={style.segmentBadgeWidth}
                            />
                        </Box>
                    ))}
                </Box>
                {props.onResolveAssetRisks !== undefined && (
                    <Button variant="Secondary" icon={<Event />} onClick={props.onResolveAssetRisks}>
                        {t("AssetManagement.value.unlockRemainingFleetValue.resolveAssetRisks")}
                    </Button>
                )}
            </Box>
        </Card>
    );
};
